import { ISpecification, ISpecificationType } from 'app/services/specification';
import { IList } from 'app/shared';
import { SET_SPECIFICATIONS, SET_SPECIFICATION, SpecificationActionTypes, SpecificationStore, SET_SPECIFICATION_TYPES } from './types';

const initialState: SpecificationStore = {
    specifications: {} as IList<ISpecification[]>,
    specificationTypes: {} as IList<ISpecificationType[]>,
    specification: {} as ISpecification
};

export function specificationReducer(state = initialState, action: SpecificationActionTypes): SpecificationStore {
    switch (action.type) {
        case SET_SPECIFICATIONS:
            return {
                ...state,
                specifications: action.specifications
            };
        case SET_SPECIFICATION_TYPES:
            return {
                ...state,
                specificationTypes: action.specificationTypes
            };
        case SET_SPECIFICATION:
            return {
                ...state,
                specification: action.specification
            };
        default:
            return state;
    }
}